"use strict";

const getSessionStorage = (key) => {
    try {
        const value = sessionStorage.getItem(key);

        return JSON.parse(value);
    } catch (error) {
        console.error(`Error getting value from sessionStorage: ${error}`);
        return null;
    }
};

const setSessionStorage = (key, value) => {
    try {
        const serializedValue = JSON.stringify(value);

        sessionStorage.setItem(key, serializedValue);
    } catch (error) {
        console.error(`Error setting value in sessionStorage: ${error}`);
    }
};

const removeSessionStorageKey = (key) => {
    sessionStorage.removeItem(key);
};

export { getSessionStorage, setSessionStorage, removeSessionStorageKey };
